import Typography from '@components/common/typography';
import { IModalComponentProps } from '@context/modal_context';
import { FC } from 'react';
import styles from './styles.module.scss';

const CancelGiftCardModal: FC<IModalComponentProps<{ isBulk: boolean; hasActivatedCards: boolean }>> = ({
    modalData: { isBulk, hasActivatedCards }
}) => {
    const message = hasActivatedCards
        ? isBulk
            ? "Request cancellation of these gift cards? Once support approves, the unredeemed balance is refunded to you; any amount already redeemed by customers isn't reversed."
            : "Request cancellation of this gift card? Once support approves, the unredeemed balance is refunded to you; any amount the customer already redeemed isn't reversed."
        : isBulk
          ? 'Are you sure you want to cancel these gift cards? This action cannot be undone.'
          : 'Are you sure you want to cancel this gift card? This action cannot be undone.';
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                {isBulk ? 'Cancel gift cards' : 'Cancel gift card'}
            </Typography>
            <Typography variant="body3" alignment="center">
                {message}
            </Typography>
        </div>
    );
};

export default CancelGiftCardModal;
